/** チャンネルイベント定義の状態の評価方法 */
export type ObservationModeType = 'TO_ALARM' | 'ON_ALARM' | 'ON_CHANGE';
export const ObservationModeTypes: ObservationModeType[] = ['TO_ALARM', 'ON_ALARM', 'ON_CHANGE'];
export function convertObservationModeType(s?: string, undef?: boolean) {
  for (const v of ObservationModeTypes) if (v === s) return s;
  return undef ? undefined : ObservationModeTypes[0];
}
